<div class="container-fluid m-0 p-0" *ngIf="!showLoader">

    <form [formGroup]="updateSemesterStudentGroup"  (submit)="updateSemesterStudentGroupSubmit()">



        <div class="row bg-white page-head p-3 d-flex flex-wrap justify-content-between">
            <div class="col-md-6 d-flex align-self-center justify-content-center justify-content-lg-start">
                <h6 class="font-bold m-0">{{"SEMESTER_STUDENT_GROUPS_UPDATE" | translate | titlecase }}</h6>
            </div>
            <div class="col-md-6 d-flex flex-wrap justify-content-center justify-content-lg-end">
                <button type="button" class="btn btn-outline-secondary m-2 rounded-0" routerLink="/enrolment/semester-student-group"
                    *ngIf="!updating">
                    {{"CANCEL" | translate | titlecase }}</button>
                <button type="submit" class="btn btn-primary m-2 rounded-0" *ngIf="!updating"><i
                        class="fas fa-user-plus"></i>
                    {{"SAVE" | translate | titlecase }}</button>
                <app-loader [show]="updating"></app-loader>
            </div>


        </div>

        <div class="row mt-4">

            <div class="col-12">

                <div class="row bg-white border m-0 py-3 ">
                    <!-- <div class="col-md-10 mx-md-auto pt-md-5 px-md-5">
                        <img src="assets/images/avatar.png" class="img-fluid">
                    </div> -->

                    <div class="col-md-10 mx-md-auto py-3">
                        <div class="row">
                            <!-- <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">User Status</label>
                                <select class="form-control custom-select" readonly disabled>
                                    <option value="">Select</option>
                                    <option value="Activated" selected>Activated</option>
                                </select>
                            </div> -->
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"CODE" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="code">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateSemesterStudentGroup.controls.code.touched && updateSemesterStudentGroup.controls.code.invalid && updateSemesterStudentGroup.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ARABIC_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameAr">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateSemesterStudentGroup.controls.nameAr.touched && updateSemesterStudentGroup.controls.nameAr.invalid && updateSemesterStudentGroup.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{"ENGLISH_NAME" | translate | titlecase }}</label>
                                <input type="text" class="form-control" formControlName="nameEn">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateSemesterStudentGroup.controls.nameEn.touched && updateSemesterStudentGroup.controls.nameEn.invalid && updateSemesterStudentGroup.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "GROUP_TYPE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="type">
                                    <option [ngValue]="">{{ "SELECT" | translate | titlecase }}</option>
                                    <option value="THEO">{{ "THEORY_GROUP" | translate | titlecase }}</option>
                                    <option value="CLNC">{{ "CLINICAL_GROUP" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateSemesterStudentGroup.controls.type.touched && updateSemesterStudentGroup.controls.type.invalid && updateSemesterStudentGroup.dirty">
                                    {{"PLEASE_SELECT" | translate | titlecase}}
                                </div>
                            </div> 
                           
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold">{{ "ORDER_NUMBER" | translate | titlecase }}</label>
                                <input type="number" class="form-control" formControlName="orderNo">
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateSemesterStudentGroup.controls.orderNo.touched && updateSemesterStudentGroup.controls.orderNo.invalid && updateSemesterStudentGroup.dirty">
                                    {{ "THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>    

                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "ACTIVE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="active"
                                    (change)="changeactive()">
                                    <option value="">{{ "SELECT" | translate | titlecase }}</option>
                                    <option value="YES">{{ "YES" | translate | titlecase }}</option>
                                    <option value="NO">{{ "NO" | translate | titlecase }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateSemesterStudentGroup.controls.active.touched && updateSemesterStudentGroup.controls.active.invalid && updateSemesterStudentGroup.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                            
                            <div class="col-md-6 form-group px-md-5 mb-4">
                                <label class="font-bold"> {{ "COURSE" | translate | titlecase }}</label>
                                <select class="form-control custom-select" formControlName="course">
                                    <option value="" [selected]="true">{{ "SELECT" | translate | titlecase }}</option>
                                    <option *ngFor="let res of courses" [ngValue]="res.id">{{
                                        (globals.lang == 'ar')? res.subjectNameAr : res.subjectNameEn
                                        }}</option>
                                </select>
                                <div class="alert alert-danger py-1 mt-1"
                                    *ngIf="updateSemesterStudentGroup.controls.course.touched && updateSemesterStudentGroup.controls.course.invalid && updateSemesterStudentGroup.dirty">
                                    {{"THIS_FIELD_IS_REQUIRED" | translate | titlecase }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<app-loader [attr.show]="showLoader"></app-loader>